import React, { useEffect, useState } from 'react'
import { Btn, CustomCheckbox, CustomModal, InputText } from '../../../../components'

const ModalRotaEntrega = React.memo(function ({ rota, isVisible, onClose, onResponse }) {
  // Hooks
  const [selectedRota, setSelectedRota] = useState(undefined)

  useEffect(() => {
    setSelectedRota({ ...rota })
  }, [rota])

  // Events
  const onBtnSalvarClicked = () => {
    if (selectedRota.nome.trim().length === 0) {
      onResponse('error', 'O campo Nome da Rota é Obrigatório')
    } else {
      onResponse('success', selectedRota)
    }
  }

  // Render
  return (
    <CustomModal
      header={selectedRota && selectedRota.id ? 'Editando Rota' : 'Nova Rota'}
      isVisible={isVisible}
      onClose={onClose}
    >
      <div className="p-grid">
        <div className="p-col-12">
          <InputText
            label="Nome Fantasia :"
            marginTop={10}
            value={selectedRota && selectedRota.nome ? selectedRota.nome : ''}
            onChange={value => setSelectedRota({ ...selectedRota, nome: value })}
          />
        </div>
        <div className="p-col-6">
          <CustomCheckbox
            checked={selectedRota ? selectedRota.ativo === 1 : true}
            onChange={value => setSelectedRota({ ...selectedRota, ativo: value ? 1 : 0 })}
          >
            Ativo
          </CustomCheckbox>
        </div>
        <div className="p-col-6">
          <CustomCheckbox
            checked={selectedRota ? selectedRota.utilizar_pallet_compartilhado === 1 : false}
            onChange={value =>
              setSelectedRota({ ...selectedRota, utilizar_pallet_compartilhado: value ? 1 : 0 })
            }
          >
            Utilizar Pallet Compartilhado
          </CustomCheckbox>
        </div>
        <div className="p-col-12">
          <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
        </div>
      </div>
    </CustomModal>
  )
})

export default ModalRotaEntrega
